;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      modal_name: "addAgentServicesModal",
      modal_target: "#addAgentServicesModal",
      merchant_id: null,
      service_id: null,
      service_name: null,
      service_currency: null,
      service_currency_id: null,
      consumer_secret: null,
      consumer_key: null,
      api_token: null,
      service_margin: 0,
      agent_margin: 0,
      total_margin: 0,
      agents: [],
      success_callback_url: null,
      action: null
    };
  },

  mounted: function mounted() {
    this.consumer_secret = this.$attrs["con_secret"];
    this.consumer_key = this.$attrs["con_key"];
  },
  created: function created() {
    this.agents = this.$attrs["agents"];
    this.merchant_id = this.$attrs["merchant_id"];
    this.service_id = this.$attrs["item_id"];
    this.service_name = this.$attrs["service_name"];
    this.service_currency = this.$attrs["service_currency"];
    this.service_currency_id = this.$attrs["service_currency_id"];
    this.service_margin = this.$attrs["service_margin"];
    this.modal_name = this.modal_name + "_" + this.service_id;
    this.modal_target = this.modal_target + "_" + this.service_id;
    this.success_callback_url = this.$attrs["current_merchant"] + "/agent-services";
    this.action = this.$attrs["type"];
  },
  methods: {
    getOauthToken: function getOauthToken() {
      var _this = this;

      var url = "/api/oauth/generate/token";
      var payload = {
        secret: this.consumer_secret,
        key: this.consumer_key
      };
      Vue.axios.post(url, payload).then(function (response) {
        _this.api_token = response.data.token;
        _this.createService();
      }).catch(function (error) {}).then(function () {});
    },
    getDeactivateOauthToken: function getDeactivateOauthToken() {
      var _this2 = this;

      var url = "/api/oauth/generate/token";
      var payload = {
        secret: this.consumer_secret,
        key: this.consumer_key
      };
      Vue.axios.post(url, payload).then(function (response) {
        _this2.api_token = response.data.token;
        _this2.dropService();
      }).catch(function (error) {}).then(function () {});
    },
    recalculateMargin: function recalculateMargin() {
      this.total_margin = parseFloat(this.service_margin) + parseFloat(this.agent_margin);
    },
    createService: function createService() {
      var _this3 = this;

      var urlIs = "/api/agent/service/create";
      var api_headers = { Authorization: "Bearer " + this.api_token };
      var api_params = {
        service_id: this.service_id,
        margin: this.total_margin,
        merchant_id: this.merchant_id
      };
      Vue.axios.post(urlIs, api_params, {
        headers: api_headers
      }).then(function (response) {
        if (response.data.status == 422) {
          _sweetalert2.default.fire({
            icon: "error",
            title: "Oops...",
            text: "Ensure the service is not already added !"
          });
        } else {
          $(_this3.modal_target + " .close").click();
          _sweetalert2.default.fire({
            position: "top-end",
            icon: "success",
            title: "Service has been added",
            showConfirmButton: false,
            timer: 3000
          });

          location.reload();
        }
      }).catch(function (error) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!"
        });
      }).then(function () {});
    },
    dropService: function dropService() {
      var _this4 = this;

      var urlIs = "/api/agent/service/drop";
      var api_headers = { Authorization: "Bearer " + this.api_token };
      var api_params = {
        id: this.service_id
      };
      Vue.axios.post(urlIs, api_params, {
        headers: api_headers
      }).then(function (response) {
        if (response.data.status == 422) {
          _sweetalert2.default.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went horribly wrong !"
          });
        } else {
          $(_this4.modal_target + " .close").click();
          _sweetalert2.default.fire({
            position: "top-end",
            icon: "success",
            title: "Service has been deactivated",
            showConfirmButton: false,
            timer: 4000
          });

          location.reload();
        }
      }).catch(function (error) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!"
        });
      }).then(function () {});
    },
    deactivateService: function deactivateService() {
      var _this5 = this;

      _sweetalert2.default.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, de-activate it!"
      }).then(function (result) {
        if (result.value) {
          _this5.getDeactivateOauthToken();
        }
      });
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.action==='add')?_c('a',{staticClass:"btn btn-sm btn-primary",attrs:{"href":"#","data-toggle":"modal","data-target":_vm.modal_target}},[_c('span',{staticClass:"fe fe-plus"})]):_vm._e(),_vm._v(" "),(_vm.action==='del')?_c('a',{staticClass:"btn btn-sm btn-danger",attrs:{"href":"#"},on:{"click":_vm.deactivateService}},[_c('span',{staticClass:"fe fe-trash"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":_vm.modal_name,"tabindex":"-1","role":"dialog","aria-labelledby":_vm.modal_name,"aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('form',{attrs:{"onsubmit":"return false;"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"overflow":"auto"}},[_c('div',{staticClass:"md-form mb-5"},[_c('label',{attrs:{"data-error":"wrong","data-success":"right"}},[_vm._v("Service Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.service_name),expression:"service_name"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.service_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.service_name=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"data-error":"wrong","data-success":"right"}},[_vm._v("Select Merchant User")]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.agents,"label":"name"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"data-error":"wrong","data-success":"right"}},[_vm._v("Service Cost")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.service_margin),expression:"service_margin"}],staticClass:"form-control",attrs:{"type":"number","readonly":""},domProps:{"value":(_vm.service_margin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.service_margin=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"data-error":"wrong","data-success":"right"}},[_vm._v("Agent Margin")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.agent_margin),expression:"agent_margin"}],staticClass:"form-control",attrs:{"type":"number","min":"0","placeholder":"e.g 30"},domProps:{"value":(_vm.agent_margin)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.agent_margin=$event.target.value},_vm.recalculateMargin]}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"data-error":"wrong","data-success":"right"}},[_vm._v("Total Margin")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.total_margin),expression:"total_margin"}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.total_margin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.total_margin=$event.target.value}}})],1)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("Close")]),_vm._v(" "),_c('input',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"Submit"},on:{"click":_vm.getOauthToken}})])])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Add Agent Service")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1f6206d5", __vue__options__)
  } else {
    hotAPI.reload("data-v-1f6206d5", __vue__options__)
  }
})()}